enum MockConstituentId {
  // 12345
  INVALID_CONNECTION = 'cnxUGpfcUxWS0RSa0NGOVZZRFpKM2k0Zw==',
  // Abby
  INVALID_FORM_CONNECTION = 'cnxdGpEMk1mM0JTSXFMZ1ZWZ3BCN0Nwdw==',
  // Reed Richards
  VALID_CONNECTION = 'cnxMXpVdTdqN2pRaXlaSGhkNHB2Vk9Xdw==',
  // Tony Stark
  VALID_FORM_CONNECTION = 'cnxdi0zSW9aNVVTaUtUR3RTa1JMaWVrUQ==',
}

export default MockConstituentId;
